export default "__VITE_ASSET__3fWAQ42i__"